import React from 'react';
import LandbotChatbot from "./chatbot.js";

const ContactUs = () => {
  return (
    <div>
      <LandbotChatbot />
    </div>
  );
};

export default ContactUs;
